import styled from '@emotion/styled'

import CopyTextBase, * as CopyText from '@segment/matcha/recipes/CopyText'
import SectionBase, * as Section from '@segment/matcha/recipes/Section'

import ActImage from './ActImage'

const copy = {
  overline: `Act`,
  heading: `How you take action using your data`,
  description: `The ability to take action on your customer data means customer interactions are personalized consistently in real time across all channels, resulting in lower customer acquisition costs and increased loyalty and customer lifetime value.`,
}

const Act = () => (
  <SectionBase variant="2Col">
    <SectionCopy alignSelf="center">
      <CopyTextBase>
        <CopyText.Overline>{copy.overline}</CopyText.Overline>
        <CopyText.Heading tag="h2">{copy.heading}</CopyText.Heading>
        <CopyText.Description variant="pLarge" tag="p">
          {copy.description}
        </CopyText.Description>
      </CopyTextBase>
    </SectionCopy>
    <Section.Contents>
      <ActImage />
    </Section.Contents>
  </SectionBase>
)

const SectionCopy = styled(Section.Copy)`
  max-width: 440px;
`

export default Act
